// 提交待定
import React, {useState, useRef, forwardRef, useImperativeHandle, useEffect} from 'react';
import request, { METHODS } from '@/api';
import UrlConfig from "@/api/UrlConfigs";
import {
  Form,
  Row,
  Col,
  message,
  Radio,
} from 'antd';
import { SFuncModal } from 'shj-components';
import {cluePending} from "@/services/callCenter";
import {getBusinessDictList} from "@/services/product.ts";
import {get} from "lodash-es";

const ModalPendingSubmissionModel: React.FC<any> = forwardRef(({ fn, onClose, ...rest }, ref) => {
  const [form] = Form.useForm();
  const [list, setList] = useState([])

  useEffect(() => {
    getData()
  }, []);

  const getData = () => {
    getBusinessDictList({ data: { priKey: 'Zabandonreason', enabled: true } }).then(res => {
      const list = get(res, '[0].children[0].children', [])
      setList(list)
    })
  }

  const handleSubmit = (value: any) => {
    return new Promise((resolve, reject) => {
      try {
        const reasonName = list.find(item => item.object?.priKey === value.reasonCode)?.label
        const { id } = rest;
        cluePending({
            ...value,
            reasonName,
            buttonKey: rest.buttonKey,
            clueId: id,
        })
          .then((res: any) => {
            message.success(res?.data?.message || '操作成功');
            fn && fn();
            onClose && onClose();
            resolve({})
          })
          .finally(() => {
            resolve({})
          });
      } catch { resolve({}) }
    })

  };
  
  useImperativeHandle(
    ref,
    () => ({
      form: form,
      onFinish: handleSubmit
    }),
    [form, handleSubmit],
  );
  return (
    <Form layout="vertical" form={form} onFinish={handleSubmit}>
      <Row gutter={12}>
        <Col span={24}>
          <Form.Item label="原因" name="reasonCode" rules={[{ required: true, message: '请选择' }]}>
            <Radio.Group>
              {list.map((item:Record<string,any>) => {
                return (
                  <Radio.Button
                    key={item?.id}
                    style={{ margin: '0 10px 10px 0', borderLeftWidth: '1px' }}
                    value={item?.object?.priKey}
                  >
                    {item?.label}
                  </Radio.Button>
                );
              })}
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
})
export function modalCallPendingSubmissionModelFn({ fn, ...rest } = {}) {
  const destroy = () => {
    dialog.destroy();
  };
  const dialog: any = SFuncModal({
    title: '提交待定',
    width: 800,
    vanish: true,
    content: <DioPendingSubmissionDom fn={fn} onClose={destroy} {...rest} />,
  });
}
const DioPendingSubmissionDom: React.FC<any> = ({ fn, onClose, ...rest }) => {
  const addRef = useRef(null);
  const [loading, setLoading] = useState(false);
  return <SFuncModal.Content
    cancelText="取消"
    onCancel={() => { onClose?.(); }}
    onOk={() => {
      setLoading(true);
      addRef?.current?.form?.validateFields().then(async res => {
        await addRef?.current?.form?.submit();
        setLoading(false);
      }).catch(() => { setLoading(false); });
    }}
    confirmLoading={loading}
  >
    <ModalPendingSubmissionModel ref={addRef} onClose={onClose} fn={fn} {...rest} />
  </SFuncModal.Content>
}